import { ReturnStatement } from '@angular/compiler';
import { Question } from '../shared/question';
import { Response } from '../shared/response';
import { ApplicationStorage } from './applicationStorage';
//@ts-ignore
import moment from 'moment';

/**
 * Survey: Senzatii noi cu Ploom - Sobranie Sticks Amber & Burgundy
 *
 * Subject: Senzatii noi cu Ploom. Cum ti s-au parut?
 * Preview: Părerea ta e importantă pentru noi!
 */
export class SurveyBurgundy {

    age: any;
    segment: any;
    endgame: boolean;
    surveyOutroText: any;
    keepAge: any;

    question1_burgundy: Question;
    question1_amber: Question;
    question2: Question;
    question3: Question;
    question3a: Question;
    question4: Question;
    question4a_aura: Question;
    question4b_advanced: Question;
    question5: Question;

    questions: Array<Question>;

    constructor(private applicationStorage: ApplicationStorage) {
        this.endgame = false;

        // =====================================================
        // Întrebarea 1: Cum ti se par noile sortimente Sobranie Sticks?
        // Pe o scală de la 1 la 5 (5 fiind cea mai mare apreciere)
        // =====================================================

        // 1a. Burgundy
        this.question1_burgundy = new Question(1, [],
            'Cum ți se pare noul sortiment Sobranie Burgundy Sticks ?',
            'Pe o scală de la 1 la 5 (5 fiind cea mai mare apreciere)',
            'radio-inline',
            [
                new Response(0, '1'),
                new Response(1, '2'),
                new Response(2, '3'),
                new Response(3, '4'),
                new Response(4, '5')
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true,
            undefined,
            undefined,//'./assets/images/sobranie_burgundy.png',
            'before'
        );

        // 1b. Amber
        this.question1_amber = new Question(2, [1],
            ' Cum ți se pare noul sortiment Sobranie Amber Sticks ?',
            ' Pe o scală de la 1 la 5 (5 fiind cea mai mare apreciere)',
            'radio-inline',
            [
                new Response(0, '1'),
                new Response(1, '2'),
                new Response(2, '3'),
                new Response(3, '4'),
                new Response(4, '5')
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true,
            undefined,
            undefined,//'./assets/images/sobranie_amber.png',
            'before'
        );

        this.question1_amber.render = () => {
            let question1BurgundyResponses = this.question1_burgundy.responses.filter(r => r.selected);
            if (question1BurgundyResponses.length > 0) {
                this.endgame = false;
                return true;
            } else {
                this.question1_amber.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;
            }
            return false;
        }

        // =====================================================
        // Întrebarea 2: Ce sortimente Sobranie Sticks pentru Ploom utilizezi cel mai des?
        // Checkbox cu imagini - 11 SKU-uri din portofoliul before launch
        // =====================================================
        this.question2 = new Question(3, [2],
            'Ce sortimente Sobranie Sticks pentru Ploom utilizezi cel mai des?',
            '',
            'checkbox',
            [
                new Response(0, 'Sobranie Bronze Sticks', [], './assets/images/Bronze.png'),
                new Response(1, 'Sobranie Burgundy Sticks', [], './assets/images/Burgundy.png'),
                new Response(2, 'Sobranie Tan Sticks', [], './assets/images/Tan.png'),
                new Response(3, 'Sobranie Amber Sticks', [], './assets/images/Amber.png'),
                new Response(4, 'Sobranie Gold Sticks', [], './assets/images/Gold.png'),
                new Response(5, 'Sobranie Silver Sticks', [], './assets/images/Silver.png'),
                new Response(6, 'Sobranie Velvet Sticks', [], './assets/images/Velvet.png'),
                new Response(7, 'Sobranie Marine Sticks', [], './assets/images/Marine.png'),
                new Response(8, 'Sobranie Green Sticks', [], './assets/images/Green.png'),
                new Response(9, 'Sobranie Azure Sticks', [], './assets/images/Azure.png'),
                new Response(10, 'Sobranie Teal Sticks', [], './assets/images/Teal.png')
            ],
            false,
            'vertical',
            undefined,
            1,  // type_id_checkbox = 1 pentru afișare imagini
            false,  // has_logo = false
            '',
            true
        );

        this.question2.render = () => {
            let question1AmberResponses = this.question1_amber.responses.filter(r => r.selected);
            if (question1AmberResponses.length > 0) {
                this.endgame = false;
                return true;
            } else {
                this.question2.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;
            }
            return false;
        }

        // =====================================================
        // Întrebarea 3: Intenționezi să adaugi în ritualul tău zilnic unul dintre cele 2 sortimente noi?
        // DA / NU - dacă DA, se deschide o nouă întrebare
        // =====================================================
        this.question3 = new Question(4, [3],
            'Intenționezi să adaugi în ritualul tău zilnic unul dintre cele 2 sortimente noi?',
            '',
            'radio',
            [
                new Response(0, 'Da'),
                new Response(1, 'Nu')
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true
        );

        this.question3.render = () => {
            let question2Responses = this.question2.responses.filter(r => r.selected);
            if (question2Responses.length > 0) {
                this.endgame = false;
                return true;
            } else {
                this.question3.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;
            }
            return false;
        }

        // 3a. Dacă DA - Pe care? (checkbox cu cele 2 noi sortimente)
        this.question3a = new Question(5, [4],
            'Pe care?',
            '',
            'checkbox',
            [
                new Response(0, 'Sobranie Burgundy Sticks', [], './assets/images/Burgundy.png'),
                new Response(1, 'Sobranie Amber Sticks', [], './assets/images/Amber.png')
            ],
            false,
            'vertical',
            undefined,
            1,  // type_id_checkbox = 1 pentru afișare imagini
            false,  // has_logo = false
            '',
            true
        );

        this.question3a.render = () => {
            let question3Responses = this.question3.responses.filter(r => r.selected);
            let selectedDa = question3Responses.find(r => r.text === 'Da');

            if (selectedDa) {
                this.endgame = false;
                return true;
            } else {
                this.question3a.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        // =====================================================
        // Întrebarea 4: Ce dispozitiv Ploom utilizezi în prezent?
        // =====================================================
        this.question4 = new Question(6, [4, 5],
            'Ce dispozitiv Ploom utilizezi în prezent?',
            '',
            'radio',
            [
                new Response(0, 'Ploom AURA', [], './assets/images/ploom_aura.png'),
                new Response(1, 'Ploom X Advanced', [], './assets/images/ploomx.png')
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true
        );

        this.question4.render = () => {
            let question3Responses = this.question3.responses.filter(r => r.selected);
            let question3aResponses = this.question3a.responses.filter(r => r.selected);

            // Dacă a răspuns "Da" la Q3, verificăm dacă a răspuns și la Q3a
            let selectedDa = question3Responses.find(r => r.text === 'Da');
            let selectedNu = question3Responses.find(r => r.text === 'Nu');

            if (selectedDa && question3aResponses.length > 0) {
                this.endgame = false;
                return true;
            } else if (selectedNu) {
                this.endgame = false;
                return true;
            } else {
                this.question4.responses.forEach(r => {
                    r.selected = false;
                });
                if (question3Responses.length === 0) {
                    this.endgame = true;
                }
            }
            return false;
        }

        // 4a. Dacă Ploom AURA - Cum ți se pare noua experiență Ploom AURA & Sobranie Sticks?
        this.question4a_aura = new Question(7, [6],
            'Cum ți se pare noua experiență Ploom AURA & Sobranie Sticks?',
            'Pe o scală de la 1 la 5 (5 fiind cea mai mare apreciere)',
            'radio-inline',
            [
                new Response(0, '1'),
                new Response(1, '2'),
                new Response(2, '3'),
                new Response(3, '4'),
                new Response(4, '5')
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true
        );

        this.question4a_aura.render = () => {
            let question4Responses = this.question4.responses.filter(r => r.selected);
            let selectedAura = question4Responses.find(r => r.text === 'Ploom AURA');

            if (selectedAura) {
                this.endgame = false;
                return true;
            } else {
                this.question4a_aura.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        // 4b. Dacă Ploom X Advanced - Care este principalul motiv pentru care nu ai făcut upgrade?
        this.question4b_advanced = new Question(8, [6],
            'Care este principalul motiv pentru care nu ai făcut upgrade la noul dispozitiv Ploom AURA?',
            '',
            'radio-free',
            [
                new Response(0, 'Sunt mulțumit(ă) de dispozitivul actual'),
                new Response(1, 'Nu cunosc suficiente informații despre Ploom AURA'),
                new Response(2, 'Nu am fost interesat(ă)'),
                new Response(3, 'Alt motiv')
            ],
            false,
            'vertical',
            undefined,
            undefined,
            undefined,
            '',
            true
        );

        this.question4b_advanced.render = () => {
            let question4Responses = this.question4.responses.filter(r => r.selected);
            let selectedAdvanced = question4Responses.find(r => r.text === 'Ploom X Advanced');

            if (selectedAdvanced) {
                this.endgame = false;
                return true;
            } else {
                this.question4b_advanced.responses.forEach(r => {
                    r.selected = false;
                    r.freeMessage = '';
                });
            }
            return false;
        }

        // =====================================================
        // Întrebarea 5: Orice alt gând/sugestie poate fi scris aici.
        // Free text - NOT mandatory
        // =====================================================
        this.question5 = new Question(9, [7, 8],
            'Orice alt gând sau sugestie poate fi scris aici ',
            '  ',
            'free',
            [
                new Response(0, '')
            ],
            false,
            'vertical',
            undefined,
            undefined,
            undefined,
            '',
            false  // NOT mandatory - lockDisabled = false
        );

        this.question5.render = () => {
            let question4aResponses = this.question4a_aura.responses.filter(r => r.selected);
            let question4bResponses = this.question4b_advanced.responses.filter(r => r.selected);

            // Verificăm dacă a fost răspuns la Q4a SAU Q4b
            if (question4aResponses.length > 0) {
                this.endgame = false;
                return true;
            }

            if (question4bResponses.length > 0) {
                // Dacă a selectat "Alt motiv", verificăm dacă a completat textul
                let altMotiv = question4bResponses.find(r => r.text === 'Alt motiv');
                if (altMotiv) {
                    if (this.question4b_advanced.responses[3]?.freeMessage) {
                        this.endgame = false;
                        return true;
                    }
                    return false;
                }
                this.endgame = false;
                return true;
            }

            return false;
        }

        // Construim array-ul de întrebări
        this.questions = [
            this.question1_burgundy,
            this.question1_amber,
            this.question2,
            this.question3,
            this.question3a,
            this.question4,
            this.question4a_aura,
            this.question4b_advanced,
            this.question5
        ];
    }

    getQuestions(): Array<Question> {
        return this.questions;
    }
}
